function phoneValidator({ configs, input, locale, msgs }) {
  const isLocaleFr = ['fr', 'fr-BE', 'fr-CA', 'fr-CH', 'fr-FR', 'fr-LU', 'fr-MC'].includes(locale);
  let min;
  let max;
  const rule = /(^[0-9()\-.+\s]+$)/;
  const areaCodeAllZerosRule = /^(?=000)\d{3}$/;
  const onlyDigits = input.replace(/[()\-.+\s]/g, '');

  if (configs) {
    min = configs.minDigits ? parseFloat(configs.minDigits) : 10;
    max = configs.maxDigits ? parseFloat(configs.maxDigits) : 10;
  } else {
    min = 10;
    max = 10;
  }

  if (isLocaleFr) {
    min = 3;
    max = 20;

    if (input.length < min) {
      if (msgs.min) {
        return msgs.min.replace('%s', min);
      }
      return `Value must be ${min} digits.`;
    }

    if (input.length > max) {
      if (msgs.max) {
        return msgs.max.replace('%s', max);
      }
      return `Value must be less than ${max} digits.`;
    }
  } else {
    if (onlyDigits.length < min) {
      if (msgs.min) {
        return msgs.min.replace('%s', min);
      }
      return `Value must be ${min} digits.`;
    }

    if (onlyDigits.length > max) {
      if (msgs.max) {
        return msgs.max.replace('%s', max);
      }
      return `Value must be less than ${max} digits.`;
    }
  }

  if (areaCodeAllZerosRule.test(onlyDigits.substr(0, 3))) {
    if (msgs.areacodeallzeros) {
      return msgs.areacodeallzeros;
    }
    return 'This is not a valid phone number. Please check the number and try again.';
  }

  if (!rule.test(input)) {
    if (msgs.special) {
      return msgs.special;
    }
    return 'Phone numbers can only include these special characters: ( ) - . +';
  }

  return null;
}

export default phoneValidator;
